// Librerias
import React from 'react'
import { Overlay, Popover } from "react-bootstrap";
let PropTypes = React.PropTypes
// Componentes
import { BotonRegion } from './BotonRegion.jsx';
// Styles
import * as css from './SelectCaptadores.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class SelectCaptadores extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            nuevoCaptadorVisible: false
        }
        this.mostrar_nuevoCaptador = () => {
            this.setState({ nuevoCaptadorVisible: true })
        }
        this.ocultar_nuevoCaptador = () => {
            this.setState({ nuevoCaptadorVisible: false })
        }
        this.captadorSeleccionado = (evt) => {
            let idUsuario = evt.target.value
            this.props.agregarCaptador(idUsuario)
            this.ocultar_nuevoCaptador()
        }

    }
    /*confirmarRegion = (idCaptador, data) => {
        let regiones = data.filter((region) => {
            return region.status > 0
        });
        this.props.agregarRegionesCaptador(idCaptador, regiones)
    }*/
    render() {
        return this.props.visible ?
            <div>
                {/* si no tiene ningun captador seleccionado, y el selector de nuevo captador no esta visible,
                    entonces se muestra un "captador-vacio", con la opcion de presionar en "+" y mostrar el selector */}
                {(this.props.captadores.length == 0 && this.state.nuevoCaptadorVisible == false) ?
                    <div className={cx('captador-vacio')} >
                        <div className={cx('captador-vacio-texto')}></div>
                        {/* Mostrar la opcion de agregar un captador solo si tiene los permisos */}
                        {this.props.puedeEditar ?
                            <div className={cx('captador-vacio-opcion')} onClick={this.mostrar_nuevoCaptador}></div>
                            : null
                        }
                    </div>
                    :
                    null
                }

                {this.props.captadores.map(captador =>{
                    return <Captador
                        puedeEditar={this.props.puedeEditar}
                        key={captador.idUsuario}
                        nombre={captador.nombre}
                        asignados={captador.asignados}
                        agregarCaptador={this.mostrar_nuevoCaptador}
                        quitarCaptador={this.props.quitarCaptador.bind(this, captador.idUsuario)}
                        cambiarAsignados={this.props.cambiarAsignados.bind(this, captador.idUsuario)}
                        idInventario={this.props.idInventario}
                        regiones={this.props.regiones}
                        idCaptador={captador.idUsuario}
                        regionesCaptador={captador.regiones}
                        regionesActuales={captador.regiones_actuales}
                        agregarRegionesCaptador={this.props.agregarRegionesCaptador}
                        cerrarRegion={this.props.cerrarRegion}
                    />}
                )}
                <NuevoCaptador
                    visible={this.state.nuevoCaptadorVisible}
                    captadoresDisponibles={this.props.captadoresDisponibles}
                    ocultar_nuevoCaptador={this.ocultar_nuevoCaptador}
                    captadorSeleccionado={this.captadorSeleccionado}
                />
            </div>
            :
            null
    }
}
SelectCaptadores.propTypes = {
    // objetos
    puedeEditar: PropTypes.bool.isRequired,
    captadoresDisponibles: PropTypes.arrayOf(PropTypes.object).isRequired,
    // metodos
    agregarCaptador: PropTypes.func.isRequired,
    quitarCaptador: PropTypes.func.isRequired,
    cambiarAsignados: PropTypes.func.isRequired
}

/* ############################################### SELECTOR CAPTADOR ################################################ */
// todo: mostrar boton de confirmacion al tratar de eliminar
class Captador extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            optionsVisible: false,
            inputAsignados: props.asignados,
            show: false,
            checkRegiones: props.regiones.map((region) => {
                return { cutRegion: region.cutRegion, status: props.regionesActuales.includes(region.cutRegion) ? 1 : 0 }
            })
        }
        // Metodos del menu de opciones
        this.__onClickHandler__ = (evt) => {
            // detecta cuando se hace un click fuera de este componente, cuando eso pasa y el menu es visible, lo oculta
            let clickAfuera = !this.node.contains(evt.target) && (this.nodeTrigger && !this.nodeTrigger.contains(evt.target))
            if (clickAfuera && this.state.optionsVisible)
                this._hideMenu()
        }
        this.toggleMenu = () => {
            if (this.state.optionsVisible)
                this._hideMenu()
            else
                this._showMenu()
        }
        this._showMenu = () => {
            this.setState({ optionsVisible: true })
        }
        this._hideMenu = () => {
            this.setState({ optionsVisible: false })
        }

        this.agregarCaptador = () => {
            this._hideMenu()
            this.props.agregarCaptador()
        }
        this.cambiarAsignados = () => {
            if (this.state.inputAsignados != this.props.asignados)
                this.props.cambiarAsignados(this.state.inputAsignados)
            else
                console.log('asignado e inputAsignados son iguales, no se hace el cambio')
        }
        this._onChange = (evt) => {
            this.setState({ inputAsignados: evt.target.value })
        }
        this._onKeyDown = (evt) => {
            if (evt.keyCode === 13) {
                this.cambiarAsignados()
            }
        }
        this.toggleFormRegion = (e) => {
            this.setState({
                show: !this.state.show,
                target: e.target
            })
        }
        this.handleClose = () => {
            this.setState({
                show: false
            });
        }
        this.filterRegiones = () => {
            let regiones = this.props.regiones
            let listRegiones = regiones.map((region) => {
                return { cutRegion: region.cutRegion, status: props.regionesActuales.includes(region.cutRegion) ? 1 : 0}
            });
            this.setState({
                checkRegiones: listRegiones,
            })
        }
        this.setStatusButton = (cutRegion, status) => {
            let lista = this.state.checkRegiones.map((region) => {
                if (region.cutRegion == cutRegion) {
                    return { cutRegion: cutRegion, status: status }
                } else {
                    return region;
                }
            })
            this.setState({ checkRegiones: lista })
        }

        this.setStatusButtonFinal = (status) => {
            let lista = this.state.checkRegiones.map((region) => {
                if (region.status > 0) {
                    return { cutRegion: region.cutRegion, status: status }
                } else {
                    return region;
                }
            })
            this.setState({ checkRegiones: lista })
        }
    }
    confirmarRegiones(idCaptador, checkRegiones) {
        this.props.agregarRegionesCaptador(idCaptador, checkRegiones)
        this.setStatusButtonFinal(0)
        this.handleClose()
    }
    componentDidMount() {
        document.addEventListener('click', this.__onClickHandler__)
        this.filterRegiones()
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.__onClickHandler__)
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            inputAsignados: nextProps.asignados,
            checkRegiones: nextProps.regiones.map((region) => {
                return { cutRegion: region.cutRegion, status: nextProps.regionesActuales.includes(region.cutRegion) ? 1 : 0 }
            })
        })
    }

    render() {
        const regiones = this.props.regiones
        return (
            <div>
                <div className={cx('captador-div')}>
                    <div className={cx('captador-text')} onClick={this.toggleFormRegion.bind(this)}>
                        {this.props.nombre}
                    </div>
                    {this.props.puedeEditar && this.props.idCaptador != 1 ?
                        <Overlay
                            show={this.state.show}
                            target={this.state.target}
                            placement="right"
                            onHide={this.handleClose.bind(this)}
                            rootClose
                        >
                            <Popover
                                id={this.props.idInventario}>
                                <h4>Seleccione las regiones</h4>
                                <h5>Captador: {this.props.nombre}</h5>
                                <div className={cx('formulario')}>
                                    <div className={cx('regiones')}>
                                        {regiones.map((region, index) => {
                                            const pressed = this.state.checkRegiones.find(({ cutRegion }) => region.cutRegion == cutRegion);
                                            const disponible = this.props.regionesCaptador.includes(region.cutRegion);
                                            const actual = this.props.regionesActuales.includes(region.cutRegion);
                                            return (
                                                <BotonRegion
                                                    key={index}
                                                    title={region.nombre}
                                                    value={region.cutRegion}
                                                    numero={region.numero}
                                                    disponible={disponible}
                                                    actual={actual}
                                                    buttonStatus={pressed ? (pressed.status > 0 ? true : false) : false}
                                                    setStatusButton={this.setStatusButton.bind(this)}
                                                />
                                            )
                                        })}
                                    </div>
                                    <div className={cx('formulario')}>
                                        <button className='btn btn-success' onClick={() => this.confirmarRegiones(this.props.idCaptador, this.state.checkRegiones)}>Confirmar</button>
                                    </div>
                                </div>
                            </Popover>
                        </Overlay> : null}
                    <input className={cx('captador-ammount', {
                        'captador-ammount-dirty': this.state.inputAsignados != this.props.asignados
                    })}
                        type="number"
                        value={this.state.inputAsignados}
                        onChange={this._onChange}
                        onKeyDown={this._onKeyDown}
                        onBlur={this.cambiarAsignados}
                        disabled={this.props.puedeEditar == false}
                    />
                    {/* Tiene opciones solo si tiene permisos para editar */}
                    {this.props.puedeEditar ?
                        <div className={cx('dots-container')}
                            onClick={this.toggleMenu}
                            ref={ref => this.nodeTrigger = ref}
                        >
                            <div className={cx('dots')}></div>
                        </div>
                        : null
                    }
                </div>
                <div ref={ref => this.node = ref}>
                    <ul className={cx('options', { 'options-hidden': this.state.optionsVisible == false })}>
                        <li className={cx('option')} onClick={this.agregarCaptador}>
                            Agregar Captador
                        </li>
                        <li className={cx('option-blankspace')} >&nbsp;</li>
                        <li className={cx('option')} onClick={this.props.quitarCaptador}>
                            Quitar Captador
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

/* ################################################# NUEVO CAPTADOR ################################################# */
class NuevoCaptador extends React.Component {
    render() {
        return this.props.visible ?
            <div className={cx('captador-nuevo')} >
                {/* select con los diferentes captadores */}
                <select className={cx('captador-nuevo-select')} onChange={this.props.captadorSeleccionado}>
                    <option key={0} value={0}>--</option>
                    {this.props.captadoresDisponibles.map(captador =>
                        <option key={captador.valor} value={captador.valor}>{captador.texto}</option>
                    )}
                </select>
                <div className={cx('captador-nuevo-opcion')} onClick={this.props.ocultar_nuevoCaptador}></div>
            </div>
            :
            null
    }
}



// WEBPACK FOOTER //
// ./frontEnd/components/shared/SelectCaptadores.jsx